import { render, staticRenderFns } from "./prods-detail-header.vue?vue&type=template&id=53dc3f34&scoped=true"
import script from "./prods-detail-header.vue?vue&type=script&lang=js"
export * from "./prods-detail-header.vue?vue&type=script&lang=js"
import style0 from "./prods-detail-header.vue?vue&type=style&index=0&id=53dc3f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dc3f34",
  null
  
)

export default component.exports